module.exports = __webpack_public_path__ + "static/media/we_work.a4862ff9.jpeg";